import { Box, CircularProgress } from '@mui/material';

export const CenteredCircularProgress: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100dvh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
};
